@use "../../../../globals/settings";
@use "../../../../globals/bcp";
@use "../../../../globals/bcp-2022/objects/flyouts";

.flyout-message {
  display: flex;
  justify-content: center;
  padding: bcp.nSpace(3);

  @include flyouts.separator("bottom");

  &__label {
    @include bcp.text-xl;
    color: bcp.colorVar("text-secondary");
    font-weight: bcp.$font-weight-bold;
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
$gray: #cdc8cd;
$gray-lighter: #c7c2c1;

/* stylelint-disable no-duplicate-selectors */
.flyout-message {
  &__label {
    color: bcp.colorVar("text");

    @include bcp.theme("ivt", "vulcano") {
      color: $gray;
    }

    @include bcp.theme("buderus") {
      color: $gray-lighter;
    }
  }
}
